export abstract class Component {
  get $() {
    return this.$root;
  }

  get helptext() {
    const {$helptext} = this;
    return $helptext == null ? null : $helptext.textContent;
  }
  set helptext(text) {
    const {$helptext} = this;
    if ($helptext != null) {
      $helptext.textContent = text;
    } else {
      throw new Error(`Helptext element not found in component "${this.name}"`);
    }
  }

  readonly name: string;

  protected readonly $root: HTMLElement;
  protected readonly abstract $helptext: Element | null;

  constructor($root: HTMLElement) {
    this.$root = $root;
    this.name = this.$root.dataset.name || 'unknown';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/ui/components/component.ts